import slugifyModule from 'slugify'

import { Url } from './types.js'

// Handle slugify's ESM export
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const slugify = (slugifyModule as any).default || slugifyModule

export const defaultLimitSuffix = '...'

export const limit = (string: string, maxLength: number, suffix = defaultLimitSuffix) => string.length < maxLength ? string : string.substring(0, maxLength) + suffix

export const toCamelCase = (input: string): string => convertSpecialCharactersToWords(input)
  .replace('-', ' ')
  .replace(/([a-z]{1})([A-Z]{1})/g, '$1 $2')
  .toLowerCase()
  .replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase())
  .trim()

export const toSlug = (input: string): string => slugify(convertSpecialCharactersToWords(input), { lower: true })

export const toTitleCase = (input: string): string => convertSpecialCharactersToWords(input)
  .replace('-', ' ')
  .replace(/([a-z]{1})([A-Z]{1})/g, '$1 $2')
  .split(' ').map(word => `${word.charAt(0).toUpperCase()}${word.slice(1).toLowerCase()}`).join(' ') // eslint-disable-line newline-per-chained-call
  .replace(/ [a-z]{1}/, letter => letter.toUpperCase())
  .replace(/[ ]{2,}/g, ' ')
  .trim()

export const convertSpecialCharactersToWords = (input: string): string => input
  .replace('&', 'and')
  .replace('@', 'at')
  .replace('.', 'dot')

export const isUrl = (to: Url | unknown): boolean => {
  if (typeof to !== 'string') {
    return false
  }

  return !!to.match(/^((ht|f)tp(s)?:\/\/|mailto:|sms:|tel:)/)
}

// Recursive function to transform object keys to a given case
function transformObjectCase(fn: (a: string) => string): <T>(obj: T) => T {
  return <T>(obj: T) => {
    if (Array.isArray(obj)) {
      return obj.map(item => transformObjectCase(fn)(item)) as unknown as T
    } if (!!obj && typeof obj === 'object') {
      return Object.keys(obj).reduce((acc, key) => {
        const camelCaseKey = fn(key)
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        acc[camelCaseKey] = transformObjectCase(fn)((obj as any)[key])

        return acc
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      }, {} as any)
    }

    return obj
  }
}

export const keysToCamel = transformObjectCase(toCamelCase)

export * from './types.js'
